import { takeEvery, call, put } from 'redux-saga/effects';
import {
    submitFeedbackStart,
    submitFeedbackSuccess,
    submitFeedbackFail,
    fetchFeedbackStart,
    fetchFeedbackSuccess,
    fetchFeedbackFail,
    respondFeedbackStart,
    respondFeedbackSuccess,
    respondFeedbackFail,
} from '../slices/feedbackSlice';
import { getRequest, postRequest, putRequest } from '../../network';
import { submitFeedback, getFeedback, respondFeedback } from '../apis';

// Generic handler for Feedback API calls
function* feedbackSaga(action) {
    console.log("Feedback saga called with action:", action);
    const { endpoint, method = 'get', successAction, failAction, payload = null, callback = null } = action.payload;
    const requestFunction = method === 'post' ? postRequest : method === 'put' ? putRequest : getRequest;

    try {
        const response = yield call(requestFunction, endpoint, payload);

        if (callback && typeof callback === 'function') {
            yield call(callback, response.message);
        }
        yield put(successAction(response));
    } catch (error) {
        if (callback && typeof callback === 'function') {
            let errorMessage = 'Something went wrong';
            if (error.response && error.response.data) {
                const data = error.response.data;
                if (data.message && data.errors) {
                    errorMessage = `${data.message}: ${data.errors.join(', ')}`;
                } else if (data.message) {
                    errorMessage = data.message;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            yield call(callback, errorMessage);
        }
        yield put(failAction(error.message));
    }
}

// Individual sagas
function* submitFeedbackSaga(action) {
    yield feedbackSaga({
        payload: {
            endpoint: submitFeedback,
            method: 'post',
            payload: action.payload,
            successAction: submitFeedbackSuccess,
            failAction: submitFeedbackFail,
        },
    });
}

function* fetchFeedbackSaga(action) {
    yield feedbackSaga({
        payload: {
            endpoint: getFeedback,
            successAction: fetchFeedbackSuccess,
            failAction: fetchFeedbackFail,
            payload: action.payload,
        },
    });
}

function* respondFeedbackSaga(action) {
    console.log("respondFeedbackSaga", action);
    yield feedbackSaga({
        payload: {
            endpoint: respondFeedback.replace(':id', action.payload.id),
            method: 'put',
            payload: action.payload.data,
            callback: action.payload.callback,
            successAction: respondFeedbackSuccess,
            failAction: respondFeedbackFail,
        },
    });
}

// Watcher saga
export function* watchFeedback() {
    yield takeEvery(submitFeedbackStart.type, submitFeedbackSaga);
    yield takeEvery(fetchFeedbackStart.type, fetchFeedbackSaga);
    yield takeEvery(respondFeedbackStart.type, respondFeedbackSaga);
}